import React, { Component } from 'react'
import PropTypes from 'prop-types'
import EditPressureMonitorForm from './forms/EditPressureMonitorForm'
import { Anchor } from './common/Anchor'
import FormHeader from './common/FormHeader'
import { updatePressureMonitorAction } from '../actions/pressureMonitorsActions'
import { createQueryString } from '../utils/queryParams'

class EditPressureMonitor extends Component {
  static propTypes = {
    pressureMonitor: PropTypes.object.isRequired,
    getPressureMonitor: PropTypes.func.isRequired,
    getAllAssetLocations: PropTypes.func.isRequired,
    assetLocations: PropTypes.arrayOf(PropTypes.object),
    isPressureMonitorLoading: PropTypes.bool,
    match: PropTypes.object,
  }

  componentDidMount() {
    const { getAllAssetLocations, getPressureMonitor, match } = this.props
    const qs = createQueryString({ perPage: 'all' })

    getAllAssetLocations(qs)
    getPressureMonitor(match.params.id)
  }

  render() {
    const {
      pressureMonitor,
      assetLocations,
      isPressureMonitorLoading,
    } = this.props
    const crumbs = [
      <Anchor to="/inventory/all">Inventory</Anchor>,
      <Anchor to="/inventory/all/pressure-monitors">
        Pressure Monitors
      </Anchor>,
      'Edit',
      `${pressureMonitor && pressureMonitor.pillarId
        ? pressureMonitor.pillarId
        : ''}`,
    ]

    return (
      <section className="EditPressureMonitor">
        <FormHeader crumbs={crumbs} />
        <EditPressureMonitorForm
          submitAction={updatePressureMonitorAction}
          initialValues={pressureMonitor}
          assetLocations={assetLocations}
          isPressureMonitorLoading={isPressureMonitorLoading}
          enableReinitialize
        />
      </section>
    )
  }
}

export default EditPressureMonitor
